import { adminJson } from "./adminHttp";

export async function getAdminMapsUsage() {
  return adminJson("/admin/ops/maps-usage");
}

export async function resetAdminMapsUsage() {
  return adminJson("/admin/ops/maps-usage", { method: "DELETE" });
}

export async function getAdminMapsUsageLogTail(limit = 250) {
  return adminJson(`/admin/ops/maps-usage/log-tail?limit=${encodeURIComponent(limit)}`);
}

export async function clearAdminMapsUsageLogTail() {
  return adminJson("/admin/ops/maps-usage/log-tail", { method: "DELETE" });
}
